import { render, staticRenderFns } from "./ReportsEditComponent.vue?vue&type=template&id=5d12d5cc"
import script from "./ReportsEditComponent.vue?vue&type=script&lang=js"
export * from "./ReportsEditComponent.vue?vue&type=script&lang=js"
import style0 from "./ReportsEditComponent.vue?vue&type=style&index=0&id=5d12d5cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports